// @flow

import React from 'react';
import { connect } from 'react-redux';
import Wrapper from '../atoms';
import {
  Header,
  Title,
  Date,
  StyledLink,
  NewsImage,
  ImageWrapper,
} from './newsArticleHeader.styled';
import { Container } from '../../grid';
import { dateParser, dateFormatter } from '../../../helpers';
import {
  getNewsArticleDate,
  getNewsArticleTitle,
  getNewsArticleImage,
} from '../../../store/routes';
import {
  getNewsOverviewLink,
  getNewsOverviewLinkLabel,
} from '../../../store/newsSettings';
import { type ACFImage } from '../../../types/acf';

type StateProps = {|
  date: ?string,
  title: ?string,
  image: ?ACFImage,
  link: string,
  linkLabel: string,
|};

const NewsArticleHeader = ({
  date,
  title,
  image,
  link,
  linkLabel,
}: StateProps) => (
  <Header>
    <Container>
      <Wrapper>
        {link && (
          <StyledLink to={link}>{linkLabel}</StyledLink>
        )}
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        <Date>{dateFormatter(dateParser(date))}</Date>
      </Wrapper>
    </Container>
    <Container>
      {image && (
        <ImageWrapper>
          <NewsImage
            image={image.sizes.large}
          />
        </ImageWrapper>
      )}
    </Container>
  </Header>
);

const mapStateToProps = (state): StateProps => ({
  date: getNewsArticleDate(state),
  title: getNewsArticleTitle(state),
  image: getNewsArticleImage(state),
  link: getNewsOverviewLink(state),
  linkLabel: getNewsOverviewLinkLabel(state),
});

export default connect<any, void, StateProps, any, any, any>(mapStateToProps)(NewsArticleHeader);
